import { BehaviorSubject }	from 'rxjs';
import { Component }				from '@angular/core';
import { ConfigService }    from '../../';

export interface SplashConfigProtocol {
  color:    string;
  duration: number;
  image:    string;
}

@Component({
  selector:			'electra-splash',
  styleUrls:		[ './splash.component.scss' ],
  templateUrl:	'./splash.component.html'
})
export class SplashComponent {
	config: SplashConfigProtocol;
  hidden  = false;

  get imageClass(): string {
    return this.config.image.length === 0 ? 'hide' : '';
  }

  get wrapperStyle(): any {
    return this.hidden ? {
      'background-color': this.config.color,
      'opacity':          0,
      'pointer-events':   'none'
    } : {
      'background-color': this.config.color
    }
  }

	constructor(private configService: ConfigService) {
    configService.splash.subscribe(data => { this.gotConfig(data); });

		console.log('Splash component created');
	}

	gotConfig(config: SplashConfigProtocol) {
		this.config = config;

		if (this.config.duration > 0 && !this.hidden) {
			setTimeout((t) => {
				t.hideSplash();
			}, this.config.duration, this);
		}
	}

	hideSplash() {
    this.hidden = true;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/splash/splash.component.ts